__turbopack_context__.v({
  "appCaption": "qG5-cG_appCaption",
  "appImage": "qG5-cG_appImage",
  "appItem": "qG5-cG_appItem",
  "applicationsGrid": "qG5-cG_applicationsGrid",
  "applicationsHeader": "qG5-cG_applicationsHeader",
  "applicationsSection": "qG5-cG_applicationsSection",
  "brandSection": "qG5-cG_brandSection",
  "galleryContent": "qG5-cG_galleryContent",
  "galleryHeader": "qG5-cG_galleryHeader",
  "gallerySection": "qG5-cG_gallerySection",
  "imageGrid": "qG5-cG_imageGrid",
  "metaBlock": "qG5-cG_metaBlock",
  "metaGrid": "qG5-cG_metaGrid",
  "metaLabel": "qG5-cG_metaLabel",
  "metaLeft": "qG5-cG_metaLeft",
  "metaOverview": "qG5-cG_metaOverview",
  "metaRight": "qG5-cG_metaRight",
  "metaSection": "qG5-cG_metaSection",
  "metaText": "qG5-cG_metaText",
  "metaTools": "qG5-cG_metaTools",
  "outcomesSection": "qG5-cG_outcomesSection",
  "page": "qG5-cG_page",
  "printSection": "qG5-cG_printSection",
  "processSection": "qG5-cG_processSection",
  "resultDetail": "qG5-cG_resultDetail",
  "resultItem": "qG5-cG_resultItem",
  "resultLabel": "qG5-cG_resultLabel",
  "resultValue": "qG5-cG_resultValue",
  "resultsContent": "qG5-cG_resultsContent",
  "resultsGrid": "qG5-cG_resultsGrid",
  "resultsSection": "qG5-cG_resultsSection",
  "storySection": "qG5-cG_storySection",
  "videoCaption": "qG5-cG_videoCaption",
  "videoContainer": "qG5-cG_videoContainer",
  "videoSection": "qG5-cG_videoSection",
});
